<h1>Service Providers</h1>
<nz-row [nzGutter]="24">
  <nz-col nzSpan="8" style="text-align: left;">
    <button nz-button nzType="primary" (click)="openNewProviderModal()">Add New Provider</button>
  </nz-col>
  <nz-col nzSpan="8">
    <input nz-input [(ngModel)]="spSearchTerm" placeholder="Enter Service Provider Name, Group or Location"  style=" margin-bottom: 16px;" />
  </nz-col>
  <nz-col nzSpan="8" style="text-align: right;">
    <nz-switch [(ngModel)]="showOnlyWithLocation" nzCheckedChildren="With Location" nzUnCheckedChildren="All Providers"></nz-switch>
  </nz-col>
    
</nz-row>

<nz-collapse>
  <nz-collapse-panel nzHeader="Service Provider Map" [nzActive]="true">
    <app-map-service-providers
      [serviceProviders]="filteredSPs()"
      >
    </app-map-service-providers>
  </nz-collapse-panel>
</nz-collapse>

<nz-table #spTable [nzData]="filteredSPs()" [nzFrontPagination]="true" [nzLoading]="isLoading()" [nzPageSize]="10" style="margin-top: 16px;">
  <thead>
    <tr>
      <th>Name</th>
      <th>Group</th>
      <th>Phone</th>
      <th [nzSortFn]="sortByDtLastModified()">Last Modified</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (sp of spTable.data; track sp.clientId) {
    <tr>
      <td>
        {{ sp.clientName }}
        @if (!hasLocation(sp)){
          <i nz-icon nzType="exclamation-circle" nzTheme="outline" style="color: orange; margin-right: 4px;" nz-tooltip nzTooltipTitle="No location set"></i>
        }
      </td>
      <td>{{ sp.clientGroupName || 'N/A' }}</td>
      <td>{{ sp.clientTel }}</td>
      <td>
        @if (sp.dtLastModified == null) {
        <i nz-icon nzType="exclamation-circle" nzTheme="outline" style="color: orange; margin-right: 4px;" nz-tooltip nzTooltipTitle="Never modified"></i>
        } @else {
        {{ sp.dtLastModified + 'Z' | date:'short' }}
        }</td>
      <td>
        <button nz-button nzType="primary" [disabled]="!isStatusUpdateRequestAvailable(sp.dtLastStatusRequest)" 
        (click)="requestStatusUpdate(sp)" 
        [nz-tooltip]="!isStatusUpdateRequestAvailable(sp.dtLastStatusRequest) ? 'Status update request is available every 30 minutes. Last update request was at ' + (sp.dtLastStatusRequest + 'Z' | date:'short' | date:'shortTime') : ''"
        >Request Status Update</button>
        <button nz-button nzType="primary" style="margin-left:4px" (click)="viewDetails(sp)">View/Edit Details</button>
        <button nz-button nzType="primary" nzDanger style="margin-left:4px" (click)="removeSPConnection(sp.clientId)"><nz-icon nzType="delete" nzTheme="outline"></nz-icon> Remove</button>
      </td>
    </tr>
  }
  </tbody>
</nz-table>

<app-service-provider-edit
  [isVisible]="isModalVisible()"
  [provider]="selectedSP()"
  (visibleChange)="isModalVisible.set(false)"
  (providerSaved)="onProviderSaved($event)">
</app-service-provider-edit>